import { UserAccessModelDTO } from "./UserAccessModel";

export interface QuoteUserDetailsDTO extends UserAccessModelDTO {
    projectName: string;
}

export const GetDefaultQuoteUserDetailsDTO = (): QuoteUserDetailsDTO => {
    const retVal: QuoteUserDetailsDTO = {
        projectName: "",
        email: "",
        displayName: "",
        telephone: "",
        company: "",
        allowMarketing: false,
    };
    return retVal;
};
